import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';

const TABS = [
    { key: 'orders', label: 'إعدادات الطلبات', icon: 'ti-files' },
    { key: 'numbering', label: 'إعدادات الترقيم', icon: 'ti-hash' },
    { key: 'printing', label: 'إعدادات الطباعة', icon: 'ti-printer' },
    { key: 'alerts', label: 'إعدادات التنبيهات', icon: 'ti-bell' },
];

export default {
    name: 'SystemSettings',
    mixins: [HelperMixin],

    async created() {
        await this.CheckLoginStatus();
        if (!this.canViewPage) {
            this.$helper.ShowMessage('error', 'غير مصرح', 'صفحة إعدادات النظام متاحة لمدير النظام فقط.');
            this.href('/Home');
            return;
        }
        await this.loadSettings();
    },

    computed: {
        canViewPage() {
            return !!this.loginDetails && this.hasAdministratorOperationalAccessUi();
        },
        tabs() { return TABS; },
        groupedSettings() {
            const groups = {};
            (this.settings || []).forEach((s) => {
                const k = s.category || 'orders';
                if (!groups[k]) groups[k] = [];
                groups[k].push(s);
            });
            return groups;
        },
        currentTabRows() {
            return (this.groupedSettings[this.activeTab] || []).map((s) => ({
                ...s,
                _options: this.parseOptions(s.optionsJson),
            }));
        },
    },

    data() {
        return {
            ScreenTitle: 'إعدادات النظام',
            activeTab: 'orders',
            settings: [],
            saving: false,
        };
    },

    methods: {
        parseOptions(json) {
            if (!json) return [];
            try {
                const arr = JSON.parse(json);
                return Array.isArray(arr) ? arr : [];
            } catch {
                return [];
            }
        },

        extractError(err) {
            if (err && err.response && err.response.data) {
                return typeof err.response.data === 'string'
                    ? err.response.data
                    : (err.response.data.message || 'حدث خطأ غير متوقع');
            }
            return (err && err.message) || 'حدث خطأ غير متوقع';
        },

        async loadSettings() {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetSystemSettings();
                this.settings = (res && res.data && res.data.info) || [];
                this.normalizeBooleans();
            } catch (err) {
                this.$helper.ShowMessage('error', 'تعذّر تحميل الإعدادات', this.extractError(err));
            } finally {
                this.$blockUI.Stop();
            }
        },

        normalizeBooleans() {
            (this.settings || []).forEach((s) => {
                if (s.dataType === 'boolean') {
                    if (typeof s.value === 'string') {
                        s.value = s.value === 'true' || s.value === '1' || s.value === 'on';
                    } else {
                        s.value = !!s.value;
                    }
                } else if (s.dataType === 'number') {
                    if (s.value === null || s.value === undefined || s.value === '') {
                        s.value = 0;
                    } else {
                        const n = Number(s.value);
                        s.value = Number.isFinite(n) ? n : 0;
                    }
                }
            });
        },

        switchTab(k) {
            this.activeTab = k;
        },

        async saveSettings() {
            const ok = await Swal.fire({
                icon: 'question',
                title: 'حفظ الإعدادات',
                text: 'هل تريد حفظ التغييرات على إعدادات النظام؟',
                showCancelButton: true,
                confirmButtonText: 'حفظ',
                cancelButtonText: 'إلغاء',
            });
            if (!ok.isConfirmed) return;

            const body = {
                Settings: (this.settings || []).map((s) => ({
                    Key: s.key,
                    Value: this.serializeValue(s),
                })),
            };

            this.saving = true;
            this.$blockUI.Start();
            try {
                const res = await this.$http.UpdateSystemSettings(body);
                this.$helper.ShowMessage('success', 'تم الحفظ', (res && res.data) || 'تم تحديث الإعدادات.');
                await this.loadSettings();
            } catch (err) {
                this.$helper.ShowMessage('error', 'تعذّر الحفظ', this.extractError(err));
            } finally {
                this.saving = false;
                this.$blockUI.Stop();
            }
        },

        serializeValue(s) {
            if (s.dataType === 'boolean') return s.value ? 'true' : 'false';
            if (s.dataType === 'number') return String(Number(s.value) || 0);
            return s.value == null ? '' : String(s.value);
        },

        async resetSettings() {
            const ok = await Swal.fire({
                icon: 'warning',
                title: 'إعادة الضبط الافتراضية',
                text: 'سيتم استعادة جميع الإعدادات إلى قيمها الافتراضية. لا يمكن التراجع.',
                showCancelButton: true,
                confirmButtonText: 'إعادة الضبط',
                cancelButtonText: 'إلغاء',
                confirmButtonColor: '#ff9f43',
            });
            if (!ok.isConfirmed) return;

            this.$blockUI.Start();
            try {
                const res = await this.$http.ResetSystemSettings();
                this.$helper.ShowMessage('success', 'تمت العملية', (res && res.data) || 'تمت إعادة الضبط.');
                await this.loadSettings();
            } catch (err) {
                this.$helper.ShowMessage('error', 'تعذّر إعادة الضبط', this.extractError(err));
            } finally {
                this.$blockUI.Stop();
            }
        },
    },
};
